import React from 'react'

import { useTranslation } from 'react-i18next'

// eslint-disable-next-line max-len
import LinkIconRender from 'components/titled-link/link-icon-render/LinkIconRender'
// eslint-disable-next-line max-len
import OpenButton from 'containers/emulator/components/shared/open-button/OpenButton'

// eslint-disable-next-line max-len
import { ReactComponent as ArrowRight } from 'assets/images/icons/ArrowRight.svg'

type TData = {
    id: string
    type: string
    description: string
    url: string
}

interface IData {
    item: TData
}

const CloudItem = ({ item }: IData): React.ReactElement => {
    const { t } = useTranslation(['emulator'])

    return (
        <div className='m-cloud__item new-loader--surface'>
            <LinkIconRender title={item.type} text='small' />
            <div className='m-cloud__desc new-loader--text'>
                {item.description}
            </div>
            <div className='m-cloud__item-actions'>
                <OpenButton
                    handleClick={() =>
                        window.open(
                            item.url.includes('https://')
                                ? item.url
                                : `https://${item.url}`,
                            '_blank',
                            'noopener,noreferrer',
                        )
                    }
                >
                    {t('emulator:open')}
                    <ArrowRight className='new-loader--icon' />
                </OpenButton>
            </div>
        </div>
    )
}

export default CloudItem
